<template>
    <div
        ref="wrapper"
        class="wrapper"
        :style="{ padding: '0 ' + margin + 'px ' + margin + 'px 0'}"
    >
        <transition-group
            name="list"
            tag="span"
            @enter="enter"
            @leave="leave"
            @after-leave="afterLeave"
        >
            <template v-if="attchedTextHeight">
                <div
                    v-for="(img, index) in imgArray"
                    :key="img.id"
                    class="img-area"
                    style="font-size:0;"
                    :style="{ margin: margin + 'px 0 0 ' + margin + 'px', width: itemWidth + 'px', height: itemHeight + attchedTextHeight + 'px' , paddingTop: itemWidth + 'px'}"
                    :class="{dragging: img.isDrag}"
                    @mousedown.stop="beginDrag(img, index, $event)"
                    @mouseup.prevent.stop="stopDrag()"
                >
                    <img
                        class="show-img has-text"
                        :src="img.showUrl"
                        draggable="false"
                        @click="zoomImage(index)"
                    />
                    <div
                        :style="{height:attchedTextHeight + 'px', width:'100%', lineHeight:attchedTextHeight + 'px', position:'relative'}"
                    >
                        <slot :index="index"></slot>
                    </div>
                </div>
            </template>
            <template v-else>
                <div
                    v-for="(img, index) in imgArray"
                    :key="img.id+img.url+index"
                    class="img-area"
                    :style="{ margin: margin + 'px 0 0 ' + margin + 'px', height:itemHeight + 'px', width: itemWidth + 'px'}"
                    :class="{dragging: img.isDrag}"
                    @mousedown.stop="beginDrag(img, index, $event)"
                    @mouseup.prevent.stop="stopDrag()"
                >
                    <img
                        v-if="/(png|jpe?g|gif)/.test(img.url)"
                        class="show-img"
                        :src="img.showUrl"
                        draggable="false"
                        @click="zoomImage(index)"
                    />
                    <div
                        v-else-if="/pdf/.test(img.url)"
                        style="cursor:pointer"
                        @click="download(img)"
                    >
                        点我预览(pdf图片)
                    </div>
                    <div
                        v-else
                        style="cursor:pointer"
                        @click="download(img)"
                    >
                        点我下载(压缩包)
                        <i
                            v-if="showOnly"
                            class="el-icon-download"
                        ></i>
                    </div>
                    <div
                        v-show="!showOnly && !disabled"
                        class="tool-box"
                    >
                        <i
                            class="el-icon-edit-outline btn-zoom"
                            @click="modifyImg(index)"
                        ></i>
                        <ValidateImageInput
                            ref="hiddenInput"
                            class="hidden-input"
                            :validate-callback="validateCallback"
                            :need-cut="needCut"
                            :callback="callback"
                            :is-validate="isValidate"
                            :max-pic="maxPic"
                            :validate-rule="validateRule"
                            :dg-water-mark="dgWaterMark"
                            @getImgObj="editImageObj"
                        />
                        <i
                            class="el-icon-delete btn-delete"
                            @click="removeImage(index)"
                        ></i>
                    </div>
                    <span
                        v-if="showFileName && fileNameList.length"
                        :style="fileNameStyle"
                    >{{ fileNameList[index] }}</span>
                </div>
            </template>
            <div
                v-if="!showOnly && !isMaxPic"
                key="add"
                class="add-img"
                :style="{ margin: margin + 'px 0 0 ' + margin + 'px', height:itemHeight + 'px', width: itemWidth + 'px'}"
            >
                <i class="el-icon-plus"></i>
                <span v-if="pending">图片上传中…</span>
                <span v-if="!pending">{{ desc }}</span>
                <ValidateImageInput
                    v-if="!disabled"
                    ref="hiddenInput1"
                    class="input-upload"
                    :need-cut="needCut"
                    :validate-callback="validateCallback"
                    :callback="callback"
                    :is-validate="isValidate"
                    :max-pic="maxPic"
                    :validate-rule="validateRule"
                    :mode="'multiple'"
                    :current-length="imgArray.length"
                    :dg-water-mark="dgWaterMark"
                    @getImgObj="addImageObj"
                />
            </div>
        </transition-group>
        <ImageViewer
            :visible.sync="showModal"
            :url-list="urlList"
            :initialIndex="currentIndex"
        />
    </div>
</template>

<script>
import ImageViewer from 'components/ImageViewer';
import dragItem from './drag-item';
import ValidateImageInput from './ValidateImageInput';
import loadingGif from './loading.gif';

export default {
    name: 'DragFileUpload',
    components: {
        ValidateImageInput,
        ImageViewer,
    },
    props: {
        value: {
            type: Array,
            required: true,
            default() {
                return [];
            },
        },
        desc: {
            type: String,
            default() {
                return '添加图片';
            },
        },
        needCut: {
            type: Boolean,
            default: false,
        },
        validateCallback: {
            type: Function,
        },
        callback: {
            type: Function,
        },
        // 默认不裁剪
        ratio: {
            type: Number,
            default: -1,
        },
        // 是否增加暗水印
        dgWaterMark: {
            type: Boolean,
            default: false,
        },
        isValidate: {
            // 是否开启图片校验
            type: Boolean,
            default: true,
        },
        maxPic: {
            type: Number /* 多图模式下控制最多上传的图片张数 */,
            default: 9,
        },
        validateRule: {
            type: Object,
            default() {
                return {
                    // width: 750,
                    // height: 750,
                    // maxSize: 300, //单位kb
                    // picFormat: [] //图片格式
                    pic: {
                        picMaxSize: 300,
                        picFormat: [],
                    },
                    rar: {
                        rarMaxSize: 10240,
                        rarFormat: [],
                    }, // 压缩包
                };
            },
        },
        // 样式属性
        // 图片与图片之间的边距，及图片与边框之间的边距
        margin: {
            type: [Number, String],
            default: 10,
        },
        // 宽高比
        aspectRatio: {
            type: [Number, String],
            default: '4:3',
        },
        // 行数量
        rowCount: {
            type: [Number, String],
            default: 4,
        },

        // 浏览模式
        showOnly: {
            type: Boolean,
            default: false,
        },

        // 浏览但可拖拽排序
        showOnlyButDrag: {
            type: Boolean,
            default: false,
        },

        // 图片可带文字
        attchedTextHeight: {
            type: Number,
            default: 0,
        },
        // 返回格式，默认是一组url数组。如果为object型，则直接透传每个图片接口返回.
        dataMode: {
            type: String,
            default: 'url',
        },
        urlParamName: {
            type: String,
            default: 'url',
        },
        index: {
            type: Number,
        },
        imgObjModel: {
            type: Object,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        showFileName: {
            type: Boolean,
            default: true,
        },
        fileNameList: {
            type: Array,
            default: () => [],
        },
        fileNameStyle: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            id: 12,
            timer: null,
            dragItem: null,
            showModal: false,
            // 显示点击放大后的图片的序号
            currentIndex: 0,
            // 正在编辑的图片序号
            editIndex: null,
            // 为每个dev设置不同的key
            imgId: 0,
            // 图片的url或者object数组
            imgArray: [],
            // dataMode为object的时候，初始字段
            keys: [],
            pending: false,
            // 判断是拖拽事件 还是点击事件
            isDrag: false,
            // 初始化之后，imgArray改变才向父组件提交变化
            isInit: true,
            itemWidth: 0,
            itemHeight: 0,
            isResizing: false,
            isFirstResize: true,
            loadingGif,
            isImage: true,
            imageInfo: null,
        };
    },

    computed: {
        currentImage() {
            //  console.log(' this.imgArray = ', this.imgArray)
            if (this.imgArray.length === 0) return { url: null, id: -1 };
            return this.imgArray[
                typeof this.currentIndex === 'number' ? this.currentIndex : 0
            ];
        },
        isMaxPic() {
            return this.imgArray.length >= this.maxPic;
        },
        urlList() {
            return this.imgArray.map((item) => item.url);
        },
    },

    watch: {
        imgArray: {
            handler() {
                if (!this.isInit) {
                    const imgArr = this.formatImgArr();
                    // console.log('imgArray changed', imgArr);
                    this.$emit('input', imgArr, this.index, this.imageInfo);
                }
            },
            deep: true,
        },
    },
    mounted() {
        this.initImgArray(this.value);

        this.isInit = false;
        this.getItemWidthAndHeight();

        window.addEventListener('resize', () => {
            if (this.isFirstResize) {
                this.getItemWidthAndHeight();
                this.isResizing = true;
                setTimeout(() => {
                    this.isResizing = false;
                }, 500);
            } else if (!this.isResizing) {
                this.getItemWidthAndHeight();
                this.isResizing = true;
                setTimeout(() => {
                    this.isResizing = false;
                }, 500);
            }
        });

        document.body.addEventListener('mousemove', (event) => {
            this.dragging(event);
        });
    },

    methods: {
        initImgArray(value) {
            if (this.dataMode === 'object') {
                this.imgArray = value.map((imgObject) => this.createImgObjInObjectMode(
                    imgObject,
                    null,
                    'existing',
                ));
            } else {
                // 默认情况
                this.imgArray = value.map((url) => this.createImgObj(url));
            }
        },
        getItemWidthAndHeight() {
            if (this.$refs.wrapper && this.$refs.wrapper.clientWidth) {
                const wrapperWidth = this.$refs.wrapper.clientWidth;
                // let wrapperWidth = +this.$refs.wrapper.style.maxWidth.split('').reverse().slice(2).reverse().join('');
                this.itemWidth = (wrapperWidth - +this.margin * (this.rowCount + 1)) / this.rowCount;
                if (typeof this.aspectRatio === 'string') {
                    const ratio = this.aspectRatio.split(':');
                    this.itemHeight = (this.itemWidth / ratio[0]) * ratio[1];
                } else if (typeof this.aspectRatio === 'number') {
                    this.itemHeight = this.itemWidth / this.aspectRatio;
                }
            } else {
                // 避免第一帧没有渲染 wrapper
                setTimeout(this.getItemWidthAndHeight, 0);
            }
        },

        formatImgArr() {
            // console.log('formatImgArr');
            return this.imgArray.map((img) => {
                if (this.dataMode === 'object') {
                    return img;
                }
                return img[this.urlParamName];


                // return this.dataMode ==='object' ? img.url;
            });
        },
        _createImgObj(url) {
            let newImg = {};
            const image = new Image();
            image.src = url;
            // 当图片加载完时，采用正确图片
            image.onload = function () {
                newImg.showUrl = url;
            };

            newImg.url = url;
            newImg.showUrl = this.loadingGif;
            // eslint-disable-next-line no-plusplus
            newImg.id = this.imgId++;
            if (this.imgObjModel) {
                newImg = { ...newImg, ...this.imgObjModel };
            }
            return newImg;
        },
        // url : url 或者 一个imgObj
        createImgObj(url) {
            return this._createImgObj(typeof url === 'string' ? url : url.url);
        },
        createImgObjInObjectMode(imgObj, urlParamName, mode) {
            if (!imgObj) {
                return;
            }
            // console.log('mode = ', mode);

            if (mode === 'existing') {
                const url = imgObj[urlParamName || this.urlParamName];
                // eslint-disable-next-line consistent-return
                return {
                    ...imgObj,
                    url,
                    showUrl: url,
                };
            }
            // eslint-disable-next-line consistent-return
            return this._createImgObjInObjectMode(imgObj, urlParamName);
        },
        _createImgObjInObjectMode(imgObj, urlParamName) {
            const url = typeof imgObj === 'string' ? imgObj : imgObj[urlParamName || this.urlParamName];
            const newImg = this._createImgObj(url);
            // console.log('first newImg = ', newImg);

            // console.log('imgObj = ', imgObj);
            // console.log('url = ', url);
            // 复制object 内对象
            Object.keys(imgObj).forEach((key) => {
                if (newImg[key] == null) {
                    newImg[key] = imgObj[key];
                }
            });

            if (!newImg.MD5) {
                // 若没有MD5，补充文件名字为MD5
                const tmpArray = url.split('/');
                const fileName = tmpArray[tmpArray.length - 1];
                const MD5 = fileName.split('.')[0];

                newImg.MD5 = MD5;
            }
            // console.log('imgObj = ', imgObj);
            // console.log('newImg = ', newImg);
            return newImg;
        },

        // 开始拖动 （按下0.5s后开始拖动）
        beginDrag(item, index, event) {
            if (event.button === 2 || (this.showOnly && !this.showOnlyButDrag)) {
                return;
            }

            const target = event.currentTarget;
            /* eslint-disable */
            this.timer = setTimeout(() => {
                this.$set(item, 'isDrag', true);
                /* eslint-disable */
                this.dragItem = new dragItem(
                    this.$refs.wrapper,
                    this.imgArray,
                    item,
                    index,
                    this
                );
                /* eslint-enable */
                this.dragItem.init(target, event);
            }, 500);
            /* eslint-enable */
            event.stopPropagation();
            event.preventDefault();
        },

        // 拖动中
        dragging(event) {
            // eslint-disable-next-line no-unused-expressions
            this.dragItem && this.dragItem.move(event.clientX, event.clientY);
        },

        // 拖动结束
        stopDrag() {
            // eslint-disable-next-line no-unused-expressions
            this.timer && clearTimeout(this.timer);
            if (this.dragItem) {
                let redrawCb = () => { };
                if (this.dataMode === 'object') {
                    // console.log('stopDrag');
                    redrawCb = this.createImgObjInObjectMode;
                } else {
                    redrawCb = this.createImgObj;
                }
                this.dragItem.redraw(redrawCb);
                // 处理drag状态
                this.dragItem.currentItem.isDrag = false;
                delete this.dragItem.currentItem.isDrag;
                this.isDrag = true;
            }
            this.dragItem = null;
        },

        modifyImg(index) {
            // debugger;
            this.editIndex = index;
            const hiddenInput = this.$refs.hiddenInput && this.$refs.hiddenInput.length ? this.$refs.hiddenInput[this.editIndex] : '';
            // debugger;

            if (hiddenInput && hiddenInput.$el) {
                hiddenInput.$el.click();
            }
            // this.$refs.hiddenInput[0].$el.click();
        },

        zoomImage(index) {
            if (this.isDrag) {
                this.isDrag = false;
                return;
            }
            const img = this.imgArray[typeof index === 'number' ? index : 0];
            this.currentIndex = index;
            if (img.url) {
                this.showModal = true;
            }
        },
        removeImage(index) {
            setTimeout(() => {
                this.imgArray.splice(index, 1);
            });
        },
        editImageObj(imgObject) {
            this.imageInfo = imgObject;
            if (this.dataMode === 'object') {
                const tmp = this.imgArray[this.editIndex];
                // console.log('editImageObj');
                this.imgArray[this.editIndex] = this.createImgObjInObjectMode(
                    imgObject,
                    'url',
                );

                // 有onload异步，不能assign
                Object.keys(tmp).forEach((key) => {
                    if (!this.imgArray[this.editIndex][key]) {
                        this.imgArray[this.editIndex][key] = tmp[key];
                    }
                });
                this.imgArray = [].concat(this.imgArray);
            } else {
                this._editImageUrl(imgObject.url);
            }
        },
        _editImageUrl(url) {
            this.imgArray[this.editIndex].url = url;
            this.imgArray[this.editIndex].showUrl = url;
        },
        addImageObj(imgObject) {
            this.imageInfo = imgObject;
            if (this.dataMode === 'object') {
                this.imgArray.push(
                    this.createImgObjInObjectMode(imgObject, 'url'),
                );
            } else {
                this._addImageUrl(imgObject.url);
            }
        },
        _addImageUrl(url) {
            this.imgArray.push(this.createImgObj(url));
        },
        // 动画效果
        // beforeEnter(el) {
        //   el.style.opacity = 0;
        // },
        enter(el, done) {
            el.style.width = `${this.itemWidth}px`;
            el.style.opacity = 1;
            setTimeout(done, 1000);
        },
        leave(el, done) {
            el.style.transition = 'all 1s';
            el.style.opacity = 0;
            el.style.width = 0;
            setTimeout(done, 1000);
        },
        afterLeave(el) {
            el.style.transition = '';
        },
        download(data) {
            // window.open(data.url)
            this.$tools.linkTo(data.url, {}, true);
            // this.$tools.download(data.url);
        },
    },
};
</script>

<style lang="scss" scoped>
.wrapper {
    border: 1px solid #dfe6ec;
    position: relative;
    text-align: left;

    .add-img {
        margin: 10px 0 0 10px;
        cursor: pointer;

        input {
            z-index: 1;
            opacity: 0;
            // 出现cursor效果
            font-size: 0;
            top: 0;
            left: 0;
            position: absolute;
            width: 100%;
            height: 100%;
            cursor: pointer;
        }
    }

    .add-img,
    .img-area {
        width: 160px;
        height: 120px;
        position: relative;
        display: inline-flex;
        overflow: hidden;
        border: 1px solid #eee;
        text-align: center;
        vertical-align: top;
        color: #999;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        will-change: left, top;
        .show-img {
            cursor: zoom-in;
            max-width: 100%;
            max-height: 100%;
            display: block;

            &.has-text {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: auto;
            }
        }
    }

    /deep/ .tool-box {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 20%;
        display: flex;
        text-align: center;
        background: #fff;

        .hidden-input {
            position: absolute;
            z-index: -10;
            font-size: 0;
            left: 0;
            right: 0;
            height: 0;
            width: 0;
        }

        i {
            $padding: 5%;

            display: table-cell;
            vertical-align: middle;
            text-align: left;
            width: 50%;
            font-size: 100%;
            color: #777;
            cursor: pointer;
            -ms-text-size-adjust: none;
            -webkit-text-size-adjust: none;
            &:hover {
                color: #333;
            }
            &:first-child {
                padding-right: $padding;
                text-align: right;
            }
            &:last-child {
                padding-left: $padding;
            }
        }
    }

    .list-enter-active {
        transition: all 1s;
    }
    .list-enter {
        opacity: 0;
        width: 0;
        margin-left: 0;
    }

    .list-move {
        transition: transform 1s;
    }

    .dragging {
        animation: shake 2s normal infinite;
    }
}

@keyframes shake {
    0%,
    100% {
        transform: rotate(0deg);
    }
    10%,
    30%,
    50%,
    70%,
    90% {
        transform: rotate(5deg);
    }
    20%,
    40%,
    60%,
    80% {
        transform: rotate(-5deg);
    }
}
</style>
